<template>
  <div>
    <a-card>
      <a-form :form="modalForm">
        <template layout="inline">
          <div>
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-item
                  label="标准账期设置："
                  style="margin-top: 30px"
                >
                  <!-- 账期 -->
                  <div style="margin-top: 20px">
                    <span style="margn-left: 5px">
                      账期：
                    </span>
                    <a-input
                      controls-position="right"
                      v-model="modalForm.term"
                      placeholder="输入的账期之间以/分隔"
                      oninput="value=value.replace('.', '',).replace('-', '',)"
                      required="required"
                      :step="1"
                      maxlength="17"
                      style="width: 400px"
                      :disabled="checkDetail"
                    />
                    <span style="margn-left: 5px">
                      (天)
                    </span>
                  </div>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </template>
      </a-form>
      <div class="text-right">
        <a-button type="primary" class="add-btn" @click="saveCard" v-if="view">
          保存
        </a-button>
        <a-button type="primary" class="add-btn" @click="addCard" v-if="!view">
          编辑
        </a-button>
      </div>
    </a-card>
  </div>
</template>

<script>
import { add, getTableData } from './api'
export default {
  data() {
    return {
      targetData: [],
      loading: false,
      searchCardLoading: true,
      tableLoading: false,
      checkDetail: true,
      visible: true,
      view: false,
      modalTitle: '',
      modalForm: {
        term: null,
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
    }
  },
  mounted() {
    // 条件列表
    this._getTableData()
  },
  methods: {
    // 获取列表数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData
      const formData = {
        size: pageSize,
        current,
      }
      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        if (records[0]) {
          this.modalForm = records[0]
        }
        this.tableLoading = false
      })
    },

    //编辑
    addCard() {
      this.checkDetail = false
      this.view = true
    },
    //保存
    async saveCard() {
      if (!this.id) {
        this.id = null
      }
      try {
        if (
          this.modalForm.term == null 
        ) {
          this.$notification.warning({
            message: '提示',
            description: '请填写完信息',
          })
          return false
        }
        this.modalForm.id = this.id
        const { message } = await add(this.modalForm)
        this.visible = false
        this.checkDetail = true
        this.view = false
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this.query()
      } catch (e) {
        console.log(e)
      }
    },
  },
}
</script>

<style scoped lang="less"></style>
